import React from "react";
import {List} from 'antd-mobile';


import MobileWrapper from '../../layouts/MobileWrapper';



const Item = List.Item;



class MobileMySalaryDetail extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            data: props.fatherProps.location.state
        }

        console.log(this.state.data)

    }



    render() {

        return <div>

            <List renderHeader={() => `${this.state.data.account_monthly}工资详情`} className="my-list">
                <Item extra={this.state.data.current_base_salary}>基本工资</Item>
                <Item extra={this.state.data.current_post_salary}>岗位工资</Item>
                <Item extra={this.state.data.welfare_subsidies}>福利补贴</Item>
                <Item extra={this.state.data.leave_subsidies}>事假</Item>
                <Item extra={this.state.data.sick_leave_subsidies}>病假</Item>
                <Item extra={this.state.data.other_holidays}>其他假期</Item>
                <Item extra={this.state.data.not_punched_deduct}>未打卡扣款</Item>
                <Item extra={this.state.data.come_late_deduct}>迟到扣款</Item>
                <Item extra={this.state.data.stay_away_deduct}>旷工扣款</Item>
                <Item extra={this.state.data.wage_payable}>应发工资</Item>
                <Item extra={this.state.data.withholding_tax}>代扣个税</Item>
                <Item extra={this.state.data.pension_rates_personal}>个人养老费</Item>
                <Item extra={this.state.data.medical_rates_personal}>个人医疗费</Item>
                <Item extra={this.state.data.unemployment_rates_personal}>个人失业费</Item>
                <Item extra={this.state.data.provident_fund_rates_personal}>个人公积金</Item>
                <Item extra={this.state.data.class_hour_fee}>课时费</Item>
                <Item extra={this.state.data.allowance}>津贴</Item>
                <Item extra={this.state.data.subsidy}>补贴</Item>
                {/* <Item extra={this.state.data.invoice_tax_deduct}>发票抵税</Item> */}
                <Item extra={this.state.data.post_tax_deduct}>税后扣款</Item>
                <Item extra={this.state.data.cash}>现金</Item>
                <Item extra={this.state.data.laobaojian}>劳保健</Item>
                <Item extra={this.state.data.real_wages}>实发工资</Item>
            </List>

        </div>


    }
}

export default MobileWrapper(MobileMySalaryDetail);


// WEBPACK FOOTER //
// ./src/routes/Mobile/MobileMySalaryDetail.js